import {VideoPlayingServiceBase} from "./video-playing-service-base";
import {GameInfo} from "../games/game-info";
import {IVideoPlayer} from "./video-players/video-player.interface";
import {VideoOnDemandHlsPlayer} from "./video-players/live-stream-players/hls/video-on-demand-player-hls";
import {VideoOnDemandNativePlayer} from "./video-players/live-stream-players/native/video-on-demand-player-native";

export const VIDEO_ON_DEMAND_WATCH_TIME_LIMIT: number = 1200000;

export class VideoOnDemandPlayingService extends VideoPlayingServiceBase {

    public gaCategory = "VIDEO-ON-DEMAND";

    protected _checkIfSupported() {
        const videoEl = document.createElement('video');
        try {
            if (VideoOnDemandNativePlayer.isSupported(videoEl)) {
                return true;
            }

            return VideoOnDemandHlsPlayer.isSupported();
        } finally {
            try {
                videoEl.src = "";
                videoEl.load();
                videoEl.remove();
            } catch (err) {
                this.services.logger.error('VideoOnDemandPlayingService - Failed to release temp video element', err);
            }
        }

    }

    getVideoPlayer(gameInfo: GameInfo, videoReference: HTMLVideoElement, dontAutoSwipe?: boolean): IVideoPlayer {

        const gameType = gameInfo.gameType;
        const streamSource = gameInfo.videoSlideUrl;

        if(gameInfo.slideCover){
            videoReference.poster = gameInfo.slideCover;
        }

        //Still under discussion whether VOD should have or not watch time limit.
        const watchTimeLimit = VIDEO_ON_DEMAND_WATCH_TIME_LIMIT;

        // We need to check also if not android because Evo live stream games not working on android real device because they use WAF and they don't get referer in android native.
        if (!this.services.device.os.isAndroid && VideoOnDemandNativePlayer.isSupported(videoReference)) {
            return new VideoOnDemandNativePlayer(this.services, gameType, videoReference, streamSource, watchTimeLimit);
        }
       
        if (VideoOnDemandHlsPlayer.isSupported()) {
            return new VideoOnDemandHlsPlayer(this.services, gameType, videoReference, streamSource, watchTimeLimit);
        }

        return null;
    }
}
